import { useOutletContext } from "react-router-dom";
export const useEventContext = () => {
    return useOutletContext();
};
